
import "bootstrap/dist/css/bootstrap.css";
import * as _ from "underscore";
import { defineComponent } from "vue";

export default defineComponent({
    name: "PaperLink",
    props: ['paperid'],
    setup() {
        return {
        };
    },
    computed: {},
});
